export default __webpack_public_path__ + "static/media/ic_status.e342b36e.svg";